<template>
    <div class="individual-search-inner-container ">

<!--        <link rel="stylesheet" href="../../../scss/blocks/_service-list.scss">-->

        <ais-instant-search
            :search-client="searchClient"
            :index-name="algoliaPrefix + 'PROVIDERS'"
            :initial-ui-state="initialUiState"
            :insights-client="aa"
            :routing="routing"
        >

            <!--            :around-lat-lng-via-iP.camel="true" -->
            <ais-configure filters="active:true"
                           v-bind="searchParameters"
                           :optional-filters.camel="optionalFilters"
                           :clickAnalytics="true"
            />

            <div class="block-header bg-cream-gradient pt-md pb-sm">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-12 col-lg-12">
                            <div class="accented-header top-only middle-bar text-center">
                                <div class="heading-flex">
                                    <h1 class="heading-1 no-max text-uppercase">Find a Provider</h1>
                                </div>
                                <div class="form-spacing">
                                    <ais-search-box>
                                        <template #submit-icon><div>Search</div></template>
                                    </ais-search-box>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="mobile-filters-button btn btn-primary btn-gold" @click="showFilters">Filters</div>

            <div class="search-content">
                <div class="container">

                    <transition name="fade" mode="out-in">
                        <div class="left-panel-close-backing" v-if="showingFilters" @click.stop="hideFilters"></div>
                    </transition>

                    <div class="left-panel" :class="{ 'open': showingFilters }" @click.prevent.stop>
                        <div class="mobile-filters-close algolia-close" @click="hideFilters">Close Filters</div>

                        <div class="pagination-value">
                            <ais-stats>
                                <template #default="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }"><p>
                                    Showing {{ (page * 8) + 1 }}-{{ (page * 8) + 8 }} of {{ nbHits }} results
                                </p></template>
                            </ais-stats>
                        </div>

<!--                        <div class="refinement-group">-->
<!--                            <h4>Filter by Last Name</h4>-->


<!--                        </div>-->

                        <div class="refinement-group">
                            <h4>Filter by City</h4>
                            <ais-refinement-list attribute="city" :limit="5" show-more>
                                <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                                    <ul>
                                        <li v-if="isFromSearch && !items.length">No results.</li>
                                        <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                            <a :href="createURL(item)" @click.prevent="() => { refine(item.value); citySelected = true; }">
                                                <span class="check"></span>
                                                <span class="refinement-label">
                                                    <ais-highlight attribute="item" :hit="item"/>
                                                    <span class="count">({{ item.count.toLocaleString() }})</span>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>

                                    <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                        {{ !isShowingMore ? 'View All' : 'View Less'}}
                                    </button>

                                </div></template>
                            </ais-refinement-list>
                        </div>

                        <div class="refinement-group">
                            <h4>Filter by Specialty</h4>
                            <ais-refinement-list attribute="services" :sort-by="['name:asc']" :limit="5" :show-more-limit="100" show-more>
                                <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                                    <ul>
                                        <li v-if="isFromSearch && !items.length">No results.</li>
                                        <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                            <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                                <span class="check"></span>
                                                <span class="refinement-label">
                                                    <ais-highlight attribute="item" :hit="item"/>
                                                    <span class="count">({{ item.count.toLocaleString() }})</span>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>

                                    <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                        {{ !isShowingMore ? 'View All' : 'View Less'}}
                                    </button>

                                </div></template>
                            </ais-refinement-list>
                        </div>

<!--                        <div class="refinement-group">
                            <h4>Type</h4>
                            <ais-refinement-list attribute="type" :limit="5" show-more>
                                <template #default="{ items, isShowingMore, isFromSearch, canToggleShowMore, refine, createURL, toggleShowMore, searchForItems }"><div>

                                    <ul>
                                        <li v-if="isFromSearch && !items.length">No results.</li>
                                        <li v-for="item in items" :key="item.value" :class="{ 'is-checked': item.isRefined }">
                                            <a :href="createURL(item)" @click.prevent="refine(item.value)">
                                                <span class="check"></span>
                                                <span class="refinement-label">
                                                    <ais-highlight attribute="item" :hit="item"/>
                                                    <span class="count">({{ item.count.toLocaleString() }})</span>
                                                </span>
                                            </a>
                                        </li>
                                    </ul>

                                    <button @click="toggleShowMore" :disabled="!canToggleShowMore" v-if="canToggleShowMore">
                                        {{ !isShowingMore ? 'Show more' : 'Show less'}}
                                    </button>

                                </div></template>
                            </ais-refinement-list>
                        </div>-->

                        <ais-configure :hitsPerPage="8" />
                    </div>
                    <div class="right-panel">
                        <div class="tags-filter-reset">
                            <div class="current-filters">
                                <ais-current-refinements :transform-items="transformItems" />
                            </div>

                            <ais-clear-refinements>
                                <template #default="{ canRefine, refine, createURL }"><div>
                                    <a :href="createURL()" @click.prevent="refine" v-if="canRefine" class="clear">
                                        Clear Filters
                                    </a>
                                </div></template>
                            </ais-clear-refinements>
                        </div>

                        <ais-hits>

                            <template #item="{ item }"><div class="individual-search-result-item">
                                <div class="item-thumbnail" v-if="item.photo">
                                    <img :src="item.photo" :alt="item.name">
                                </div>

                                <div class="item-thumbnail" v-if="!item.photo">
                                    <img src="https://monument.health/wp-content/uploads/2021/04/provider-default.jpeg" :alt="item.name">
                                </div>

                                <div class="item-inner-contents">
                                    <div class="item-details">
                                        <a :href="item.epic_url || false"><h3>
                                            {{ item.name }}
                                            <svg width="6" height="10" viewBox="0 0 6 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M1 1L5 5L1 9" stroke="#963821" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                                            </svg>
                                        </h3></a>
                                        <div class="item-services">{{ formatArrayDisplay(item.services, 4) }}</div>
                                        <div class="item-location"><span v-text="item.address + ', ' + item.city + ', ' + item.state"></span></div>
                                        <a :href="'tel:' + item.phone" class="item-phone"><span v-text="formatPhoneNumber(item.phone)"></span></a>
                                    </div>

                                    <div class="item-controls">
                                        <a v-if="item.epic_url" target="_blank" :href="item.epic_url" class="btn btn-primary btn-gold">Profile</a>
                                    </div>
                                </div>

                            </div></template>

                        </ais-hits>

                        <div class="search-results-pagination bg-white">
                            <ais-pagination :show-first="false" :show-previous="true" :show-next="true" :show-last="false" />

                            <ais-stats>
                                <template #default="{ hitsPerPage, nbPages, nbHits, page, processingTimeMS, query }"><p>
                                    Showing {{ (page * 8) + 1 }}-{{ (page * 8) + 8 }} of {{ nbHits }} results
                                </p></template>
                            </ais-stats>
                        </div>

                    </div>

                </div>
            </div>

        </ais-instant-search>

    </div>
</template>

<script>
    import algoliasearch from 'algoliasearch';

    const algoliaPrefix = (window.ajax_global && window.ajax_global.algolia_prefix) ? window.ajax_global.algolia_prefix : 'prod_';
    const searchClient = algoliasearch('O4J2BVWP7X', '25e82b9ff49bfc98eeaea844742d9654');
    const index = searchClient.initIndex(algoliaPrefix + 'PROVIDERS');

    export default {

    props: ['query_in'],

    data() {
        return {
            query: '',
            originalQuery: '',
            citySelected: false,
            algoliaPrefix,
            searchClient,
            index,
            initialUiState: {
                [algoliaPrefix + 'PROVIDERS']: {
                    query: this.query_in,
                    refinementList: {
                        "active": true
                    }
                },
            },

            // optionalFilters: [],
            searchParameters: {},
            showingFilters: false,
            showingFiltersPanel: false,
            routing: {
                stateMapping: {
                    stateToRoute(uiState) {
                        const indexUiState = uiState[algoliaPrefix + 'PROVIDERS'] || {};
                        return {
                            query: indexUiState.query,
                            services: indexUiState.refinementList?.services,
                            city: indexUiState.refinementList?.city,
                            page: indexUiState.page
                        };
                    },
                    routeToState(routeState) {
                        return {
                            [algoliaPrefix + 'PROVIDERS']: {
                                query: routeState.query,
                                refinementList: {
                                    services: routeState.services,
                                    city: routeState.city
                                },
                                page: routeState.page
                            }
                        };
                    }
                }
            },
        }
    },

    mounted() {

        this.query = this.query_in;
        this.originalQuery = this.query_in;

    },

    computed: {
      optionalFilters() {
        const base = [
          'type:Doctors<score=2>',
          'type:Providers',
        ];

        if (this.citySelected) {
          base.unshift('address:640 Flormann Street<score=50>');
        }

        return base;
      }
    },

    components: {},

    watch:{

        currentRefinement: function (oldValue, newValue) {
            // window.updateUrlParameter('query', newValue);
        }

    },

    methods: {

        transformItems: function (items) {
            // console.log(items);
            for(let i = 0; i < items.length; i++) {
                if(items[i].label === 'services') {
                    items[i].label = 'Specialty';
                } else if(items[i].label === 'last_name_letter') {
                    items[i].label = 'Last Name';
                }
            }
            return items;
            // return items.filter(item => item.attribute !== 'brand');
        },

        formatPhoneNumber: function (phoneNumberString) {
            var cleaned = ('' + phoneNumberString).replace(/\D/g, '')
            var match = cleaned.match(/^(\d{3})(\d{3})(\d{4})$/)
            if (match) {
                return '(' + match[1] + ') ' + match[2] + '-' + match[3]
            }
            return null
        },

        formatArrayDisplay: function (array, maxLength = 0) {

            let returnString = '';

            if(maxLength > 0 && array.length > maxLength) {
                for (let i = 0; i < maxLength - 1; i++) {
                    if(returnString === "") {
                        returnString += this.decodeHTMLEntities(array[i]);
                    } else {
                        returnString += ', ' + this.decodeHTMLEntities(array[i]);
                    }
                }
                returnString += ' + more';
            } else {
                for (let i = 0; i < array.length; i++) {
                    if(returnString === "") {
                        returnString += this.decodeHTMLEntities(array[i]);
                    } else {
                        returnString += ', ' + this.decodeHTMLEntities(array[i]);
                    }
                }
            }

            return returnString;

        },

        decodeHTMLEntities: function (text) {
            var entities = [
                ['amp', '&'],
                ['apos', '\''],
                ['#x27', '\''],
                ['#x2F', '/'],
                ['#39', '\''],
                ['#47', '/'],
                ['lt', '<'],
                ['gt', '>'],
                ['nbsp', ' '],
                ['quot', '"']
            ];

            for (var i = 0, max = entities.length; i < max; ++i)
                text = text.replace(new RegExp('&'+entities[i][0]+';', 'g'), entities[i][1]);

            return text;
        },

        showFilters: function () {

            if(this.showingFilters) {
                this.showingFilters = false;
                setTimeout(() => {
                    this.showingFilters = true;
                }, 10);
            } else {
                this.showingFilters = true;
            }
            // this.showingFiltersPanel = true;

        },

        hideFilters: function () {

            this.showingFilters = false;
            // this.showingFiltersPanel = false;

        },

        updateInput: function () {
            console.log(this.query);
        }

    }

}
</script>
